// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable default-param-last */
// Url params - currently it is getting from MainView
export default function ParamsReducer(state = {}, action) {
  switch (action.type) {
    case "UPDATE_ROUTE":
      return action.params

    default:
      return state
  }
}
